<template>
  <v-row justify="center">
    <v-col cols="12" md="8">

      <div class="text-h6 mb-4">Dueños asignados a esta sucursal</div>

      <v-row>
        <!-- Asignados -->
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="text-subtitle-2 pb-1">Asignados</v-card-title>
            <v-divider></v-divider>
            <v-list dense v-if="dueños_sucursal.length > 0">
              <v-list-item v-for="dueño in dueños_sucursal" :key="dueño.id">
                <v-list-item-avatar color="grey lighten-3">
                  <v-icon small>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ dueño.persona.nombre }} {{ dueño.persona.apellido }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click="gestionarEmpleado(dueño, 'quitar')">
                    <v-icon small color="grey">mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-list v-else dense>
              <v-list-item>
                <v-list-item-content class="grey--text text-caption">Sin asignados</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <!-- Disponibles para asignar -->
        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title class="text-subtitle-2 pb-1">Disponibles</v-card-title>
            <v-divider></v-divider>
            <v-list dense v-if="dueños_empresa.length > 0">
              <v-list-item v-for="dueño in dueños_empresa" :key="dueño.id">
                <v-list-item-avatar color="grey lighten-3">
                  <v-icon small>mdi-account-outline</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ dueño.persona.nombre }} {{ dueño.persona.apellido }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click="gestionarEmpleado(dueño, 'asignar')">
                    <v-icon small color="primary">mdi-plus</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-list v-else dense>
              <v-list-item>
                <v-list-item-content class="grey--text text-caption">
                  Todos los dueños ya están asignados
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SucursalDueñosList",
  props: {
    sucursal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dueños_sucursal: [],
      dueños_empresa: [],
    };
  },
  methods: {
    async fetchEmpleados(uuid) {
      try {
        const response = await this.axios.get(`/empleados/asignaciones/owner/${uuid}`);
        this.dueños_sucursal = response.data.dueños_sucursal;
        this.dueños_empresa = response.data.dueños_empresa;
      } catch (error) {
        console.error(error);
      }
    },
    async gestionarEmpleado(dueño, accion) {
      try {
        const response = await this.axios.post('/empleados/asignaciones/gestion/owner', {
          dueño_id: dueño.id,
          accion: accion,
          sucursal_uuid: this.sucursal.uuid,
        });
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: response.data.detail,
          icon: "mdi-check",
          timeout: 3000,
        });
        this.fetchEmpleados(this.sucursal.uuid);
      } catch (error) {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: error.response ? error.response.data.detail : "Error inesperado",
          icon: "mdi-alert",
          timeout: 3000,
        });
      }
    },
  },
  watch: {
    sucursal: {
      immediate: true,
      handler(val) {
        if (val && val.uuid) {
          this.fetchEmpleados(val.uuid);
        }
      },
    },
  },
};
</script>
